import React from 'react';
import { ADMINISTRATION_PAGES_LIST } from './AdministrationPagesConfig';
import CommonAdministrationPage from './CommonAdministrationPage';
import RestrictedRoute from '../../common/route/restrictedRoute';

const AdministrationRoutes = () => {
  return ADMINISTRATION_PAGES_LIST.map(page =>
    <RestrictedRoute
      exact
      key={page.type}
      path={page.urlPath}
      title={page.title}
      type={page.type}
      fields={page.fields}
      component={page.component ?? CommonAdministrationPage}
    />);
};

export default AdministrationRoutes;